import React, { useState } from "react";
import {
    Visibility as VisibilityIcon,
    VisibilityOff as VisibilityOffIcon,
} from "@mui/icons-material";
import Highlight from "react-highlight";
import CopyIconButton from "components/atoms/CopyIconButton";
import { TabProps } from "../../../../SourceModal.types";
import BaseOverview from "./BaseOverview";

const isValidUrl = (urlString: string): boolean => {
    try {
        new URL(urlString);
        return true;
    } catch (err) {
        return false;
    }
};

const getJSLink = (tracker: any, id: number): string => {
    const url = tracker?.document_urls?.transition?.find((doc: string) =>
        doc.includes(`source=${id}&`),
    );
    if (!isValidUrl(url)) {
        return "";
    }
    const parsedUrl = new URL(url);
    const keyValue = parsedUrl.searchParams.get("key");
    return keyValue || "";
};

const JsOverview: React.FC<TabProps> = ({ source, tracker, language }) => {
    const [tokenAreaVisible, setTokenAreaVisible] = useState(true);

    const jsLink = getJSLink(tracker, source?.id);
    const codeSnippet = `<script language="JavaScript" type="text/JavaScript">
window.p2sq = window.p2sq || [];
p2sq.push({et:'Init',p:{
em: '{user-email}',         // Parameters
fn: '{user-first-name}',    // encrypted
ln: '{user-last-name}'      // with SHA-256
// ...
}});

p2sq.push({et: 'PageView'});  // Page View Event

!function(f, b, e, v, t, s) {f.p2sq = f.p2sq || [];if (f.p2sf) return;f.p2sf=true;
t = b.createElement(e);t.async = !0;t.src = v;s = b.getElementsByTagName(e)[0];
s.parentNode.insertBefore(t, s);
}(window,document,'script','https://cpi.ssevt.com/js/v4.2/${jsLink}');
</script>`;

    return (
        <BaseOverview language={language}>
            <div>
                <div className="bearer-token-area">
                    <span className="bearer-token-title">
                        {language?.tracker_detail?.overview
                            ?.pageview_event_title ??
                            "SignalSight Loader Code & Pageview Event"}
                        <a
                            href="javascript:;"
                            onClick={() =>
                                setTokenAreaVisible(!tokenAreaVisible)
                            }
                        >
                            {!tokenAreaVisible ? (
                                <VisibilityIcon />
                            ) : (
                                <VisibilityOffIcon />
                            )}
                        </a>
                    </span>
                    {tokenAreaVisible && (
                        <div className="bearer-token-blockquote align-items-start">
                            <Highlight className="language-name-of-snippet">
                                {codeSnippet}
                            </Highlight>
                            <CopyIconButton value={codeSnippet} />
                        </div>
                    )}
                </div>
                <p>
                    {language?.tracker_detail?.overview?.js_msg ??
                        "Track and collect data from website interactions in real-time using embedded JavaScript code. This source provides comprehensive insights into user behavior on your site. It enables event tracking such as page views, clicks, and form submissions. You can also customize the tracking to capture specific actions relevant to your business goals."}
                </p>
            </div>
        </BaseOverview>
    );
};

export default JsOverview;


